<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">G<span class="small">ETTING THE</span> M<span class="small">OST</span> O<span class="small">UT OF</span> <i>C<span class="small">HRISTIAN</span> C<span class="small">OMMUNITY</span></i></a></div>
<div class="table" id="tableau-001">
<div class="table-align">
<table border="" style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:2px;">
<col style="width:3%;padding:2px;"/>
<col style="width:55%;padding:2px;"/>
<col style="width:25%;padding:2px;"/>
</colgroup>
<tbody>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><a href="#/chap1"><b>1</b></a></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><a href="#/chap1"><b>Built to Last</b></a></p></td>
<td style="padding:2px;vertical-align:top;vertical-align:top;"><p class="SOM_chap"><a href="#/chap1"><span class="mev3">Ephesians 2:11-22</span></a></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap2" title="Link target outside of Sample"><b>2</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap2" title="Link target outside of Sample"><b>Everyone’s Involved</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev3">1 Corinthians 12</span></span></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap3" title="Link target outside of Sample"><b>3</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap3" title="Link target outside of Sample"><b>Everyone’s Invited</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev3">Philemon</span></span></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap4" title="Link target outside of Sample"><b>4</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap4" title="Link target outside of Sample"><b>We Gather Together</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev3">Psalm 100</span></span></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap5" title="Link target outside of Sample"><b>5</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap5" title="Link target outside of Sample"><b>Community Commissioned</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev3">Luke 10:1-20</span></span></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap6" title="Link target outside of Sample"><b>6</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap6" title="Link target outside of Sample"><b>Servant’s Entrance</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev3">Matthew 25:31-46</span></span></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap7" title="Link target outside of Sample"><b>7</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap7" title="Link target outside of Sample"><b>And They’ll Know We Are Christians</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="mev3">John 13:1-17, 34-35</span></span></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap8" title="Link target outside of Sample"><b>8</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap8" title="Link target outside of Sample"><b>True Confessions</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="mev3">Nehemiah 9:1-5; James 5:13-20</span></span></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap9" title="Link target outside of Sample"><b>9</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap9" title="Link target outside of Sample"><b>Confrontation &amp; Restoration</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="mev3">Matthew 18:15-35</span></span></p></td>
</tr>
<tr style="padding:2px;">
<td style="padding:2px;vertical-align:bottom;"><p class="SOM_chap2"><span href="#/chap10" title="Link target outside of Sample"><b>10</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap1"><span href="#/chap10" title="Link target outside of Sample"><b>A Haven for Healing</b></span></p></td>
<td style="padding:2px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><span class="mev3">Ezekiel 34:1-16</span></span></p></td>
</tr>
</tbody></table>
</div></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Leader’s Notes</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?2d67f631